
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";

export default {
  name: "ReportOrderFilterOptions",
  props: {
    PAYMENTS: {
      default: () => [],
      type: Array
    },
    STAGES: {
      default: () => [],
      type: Array
    },
    selectedStages: {
      default: () => [],
      type: Array
    },
    selectedChannels: {
      default: () => [],
      type: Array
    },
    selectedPayments: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      channelSelected: [],
      brandSelected: [],
      stageSelected: [],
      paymentSelected: []
    };
  },
  computed: {
    ...mapGetters("report", ["getChannels", "getSelectedRestaurantsLabel"]),
    ...mapState("restaurant", ["locationDetails"]),
    ...mapState("report", ["selectedRestaurants", "selectedOrderFilter"]),
    ...mapGetters("restaurant", ["hasMultipleBrands"]),
    appliedFilterCount() {
      let count = 0;
      if (this.selectedOrderFilter.selectedChannels.length > 0) {
        count += this.selectedOrderFilter.selectedChannels.length;
      }

      if (this.selectedOrderFilter.selectedPayments.length > 0) {
        count += this.selectedOrderFilter.selectedPayments.length;
      }
      if (this.selectedRestaurants.length > 0 && this.hasMultipleBrands) {
        count += this.selectedRestaurants.length;
      }
      if (this.selectedOrderFilter.selectedStages.length > 0) {
        count += this.selectedOrderFilter.selectedStages.length;
      }

      return count;
    }
  },
  beforeMount() {
    this.channelSelected = JSON.parse(
      JSON.stringify(this.selectedOrderFilter?.selectedChannels)
    );
    this.brandSelected = JSON.parse(JSON.stringify(this.selectedRestaurants));
    this.stageSelected = JSON.parse(
      JSON.stringify(this.selectedOrderFilter?.selectedStages)
    );
    this.paymentSelected = JSON.parse(
      JSON.stringify(this.selectedOrderFilter?.selectedPayments)
    );
    this.setFilterCount();
  },
  methods: {
    ...mapMutations("report", [
      "SET_REPORT_RESTAURANT",
      "SET_REPORT_PRODUCTS",
      "SET_ORDER_CHANNEL_FILTER",
      "SET_ORDER_STAGE_FILTER",
      "SET_ORDER_PAYMENT_FILTER",
      "SET_ORDER_FILTER_COUNT"
    ]),

    setSelectedPayment() {
      this.SET_ORDER_PAYMENT_FILTER(this.paymentSelected);
      this.setFilterCount();
    },
    setSelectedStage() {
      this.SET_ORDER_STAGE_FILTER(this.stageSelected);
      this.setFilterCount();
    },
    setSelectedChannel() {
      this.SET_ORDER_CHANNEL_FILTER(this.channelSelected);
      this.setFilterCount();
    },
    brandSelectionChange(force) {
      this.SET_REPORT_RESTAURANT(this.brandSelected);
      this.setFilterCount();

      if (force) this.SET_REPORT_PRODUCTS([]);
      this.$emit("fetch-report");
    },
    setFilterCount() {
      this.SET_ORDER_FILTER_COUNT(this.appliedFilterCount);
    }
  }
};
